import { api } from '@/lib/api'
import type { EventListQuery, EventListResponse } from '@/types/event'

/**
 * Holt Events im angegebenen Zeitfenster. Backend-default-Filter
 * (countries=US/EU/GB) gilt, wenn der Client keine countries mitschickt.
 */
export async function listEvents(query: EventListQuery): Promise<EventListResponse> {
  const params = new URLSearchParams()
  params.set('from', query.from)
  params.set('to', query.to)
  if (query.countries) {
    for (const c of query.countries) {
      params.append('countries', c)
    }
  }
  if (query.impact_min) {
    params.set('impact_min', query.impact_min)
  }
  const response = await api.get<EventListResponse>(`/events?${params.toString()}`)
  return response.data
}
